
// TODO: Review and consolidate icon packages

export default {
  // Miscellaneous
  book: "material-symbols:menu-book-outline",
  issue: "material-symbols:bug-report-outline",
  history: "material-symbols:history-2",
  journal: "bi:journal-text",
  externalLink: "i-heroicons:arrow-up-right-20-solid",
  standard: "material-symbols:book-2-outline-rounded",
  magic: "material-symbols:magic-button-outline",
  checklist: "material-symbols:list-alt-check-outline-rounded",

  // Pages
  home: "bi:house",
  help: "heroicons:question-mark-circle",
  releaseNotes: "octicon:diff",
  browse: "mdi:walk",
  search: "heroicons:magnifying-glass",
  build: "heroicons:pencil",
  validate: "heroicons:check-circle",
  transform: "heroicons:arrows-right-left",
  publish: "heroicons:cloud-arrow-up",
  migrate: "heroicons:chevron-double-right",

  // Menu items
  user: "heroicons:user-circle",
  developer: "bi:journal-code",
  preferences: "bi:sliders",
  menu: "material-symbols:menu",
  settings: "heroicons:cog-6-tooth",

  // Statuses
  info: "material-symbols:info-outline",
  success: "material-symbols:check-circle-outline",
  error: "material-symbols:error-circle-rounded",
  warning: "material-symbols:warning",
  pending: "material-symbols:pending-outline",
  unsent: "material-symbols:indeterminate-question-box",

  // Actions
  add: "material-symbols:add",
  more: "material-symbols:expand-more-rounded",
  less: "material-symbols:expand-less-rounded",
  map: "material-symbols:equal-rounded",
  copy: "tabler:copy",
  copied: "tabler:copy-check",
  close: "i-heroicons-x-mark-20-solid",
  upload: "material-symbols-light:upload-file-outline-rounded",
  download: "material-symbols-light:download-rounded",
  open: "material-symbols:arrow-circle-right-outline-rounded",
  starOutline: "material-symbols:star-outline",
  starFilled: "material-symbols:star",
  empty: "ph:empty",
  value: "ic:round-text-fields",
  sort: "mi:sort",

  // Directions and locations
  start: "material-symbols:line-start-circle-outline-rounded",
  end: "material-symbols:line-end-circle-outline-rounded",
  down: "material-symbols:keyboard-arrow-down-rounded",
  up: "material-symbols:keyboard-arrow-up-rounded",
  left: "material-symbols:chevron-left-rounded",
  right: "material-symbols:chevron-right-rounded",

  // Site brands
  github: "mdi:github",
  youtube: "mdi:youtube",
  swagger: "simple-icons:swagger",
  toolbox: "fluent:toolbox-32-regular",
  niemopen: "gravity-ui:nodes-down",

  // Formats
  xml: "ph:brackets-angle",
  cmf: "tabler:transform-filled",
  json: "ph:brackets-curly",
  rdf: "gravity-ui:nodes-right",
  owl: "material-symbols:owl-outline-rounded",
  zip: "material-symbols:folder-zip-outline-rounded",
  csv: "material-symbols:csv-outline-rounded",

  // NIEM entities
  steward: "lucide:building",
  model: "material-symbols:network-node",
  version: "solar:hashtag-circle-linear",
  namespace: "mdi:file-document-outline",
  property: "material-symbols:label-outline-rounded",
  type: "streamline:hierarchy-2",
  class: "streamline:hierarchy-2",
  datatype: "clarity:block-line",
  contents: "mdi:format-list-group",
  subproperty: "material-symbols:subdirectory-arrow-right-rounded",
  // subproperty: "bi:list-nested",
  facet: "codicon:symbol-enum",
  term: "material-symbols:dictionary-outline-rounded",
  substitution: "material-symbols:arrow-circle-right-outline-rounded"

} as const;
